import ScormAPI from '@/lib/ScormApi/ScormAPI'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'

export default function CMI_ObjectivesObject (API: ScormAPI) {
  let _id = ''
  let _status = ''
  let score__children = 'raw,min,max'
  let score__raw = ''
  let score__min = ''
  let score__max = ''

  return {
    get id () {
      return _id
    },
    set id (id) {
      _id = id
    },
    get status () {
      return _status
    },
    set status (status) {
      _status = status
    },
    score: {
      get _children () {
        return score__children
      },
      set _children (children) {
        API.throwSCORMError(402)
      },
      get raw () {
        return score__raw
      },
      set raw (raw) {
        score__raw = raw
      },
      get min () {
        return score__min
      },
      set min (min) {
        score__min = min
      },
      get max () {
        return score__max
      },
      set max (max) {
        score__max = max
      },
      toJSON: new JsonFormatter().apply
    },
    toJSON: new JsonFormatter().apply
  }
}
